<template>
    <div>
        <h3>Grundeinstellungen</h3>
        <div class="row">
            <div class="col-xl-2 col-md-3">
                <div class="form-group">
                    <label>Verbindungstyp</label>
                    <select name="connection_type" class="form-control" v-model="type">
                        <option value="ftp">FTP</option>
                        <option value="sftp">SFTP</option>
                    </select>
                </div>
            </div>
            <div class="col-xl-4 col-md-9">
                <div class="form-group">
                    <label>Host</label>
                    <input class="form-control" type="text" placeholder="IP oder URL"/>
                </div>
            </div>
            <div class="col-xl-3 col-md-6">
                <div class="form-group">
                    <label>User</label>
                    <input class="form-control" type="text" placeholder="Login"/>
                </div>
            </div>
            <div class="col-xl-3 col-md-6">
                <div class="form-group">
                    <label>Passwort</label>
                    <input class="form-control" type="text" placeholder="Passwort"/>
                </div>
            </div>
        </div>

        <div v-if="isSftp" class="mt-3">
            <h3>Erweiterte Einstellungen</h3>
            <div class="row">
                <div class="col-xl-2 col-md-6">
                    <div class="form-group">
                        <label>Verzeichnis auf Server</label>
                        <input class="form-control" type="text" name="dir" value="upload" placeholder="Verzeichnispfad"/>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!isSftp">
            <div class="row">
                <div class="col-xl-6">
                    <div class="text-muted">oder</div>
                    <div class="form-group mt-5 pt-2">
                        <button class="btn btn-light-primary">FTP-Account bereitstellen</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            type: 'ftp',
        }
    },

    computed: {
        isSftp() {
            return this.type === 'sftp'
        },
    },
}
</script>
